<template>
  <div class="gear-wrapper" :style="{width: width, height: height}">
    <img :class="['gear', rotate ? 'rotate':'', rotateReverse ? 'rotate-reverse' : '']" :src="gear" alt="">
    <img class="gear-u-cute" :src="gearText" alt="">
  </div>
</template>

<script>
import key from "@/api/key";

export default {
  name: 'gear-cute',
  props: {
    width: { type: String },
    height: { type: String },
    rotate: { type: Boolean, default: false },
    rotateReverse: { type: Boolean, default: false },
  },
  data() {
    return {
      gear: key.getByName(key.COMMON, 'gear').fileUrl,
      gearText: key.getByName(key.COMMON, 'gear-text').fileUrl,
    }
  }
}
</script>

<style scoped lang="scss">
.gear-wrapper {
  position: relative;

  .gear {
    width: 100%;
    height: 100%;

    &.rotate {
      animation: rotate 15s linear infinite;
    }

    &.rotate-reverse {
      animation: rotate-reverse 15s linear infinite;
    }
  }

  .gear-u-cute {
    width: 7.031vw;
    height: 3.125vw;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes rotate-reverse {
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
}
</style>
